export const onlyNumbersWithColon = (e) => {
  if (e.keyCode !== 8 && e.target.value.length === 2) {
    e.target.value += ':';
  }
};
